import { IApplication } from '../application/types'
import { Role } from '../role/types'
import { Job } from '../job/types'

export enum Constants {
  RESET_USER = 'RESET_USER',
  SET_CURRENT = 'SET_CURRENT',
}

export interface User {
  id: number
  firstName: string
  lastName: string
  email: string
  roleId?: Role
  jobId?: Job
  organization: any
  role: any
  applications?: IApplication[]
}

export interface ICreateOrUpdateUser {
  firstName: string
  lastName: string
  email: string
  roleId: number
  jobId: number
  organizationId: number
  segments: any[]
  networks?: any[]
}

export interface UserState {
  initialValue: any | null
  current: any | null
  users: User[]
  isOpen: boolean
  isEditUser: any
  isDeleteModalOpen: boolean
  userForDelete?: any
  userById?: any
  resetForm: boolean
}

export enum UserIncludes {
  ORGANIZATION = 'user_organization',
  NETWORKS = 'user_networks',
  SEGMENTS = 'user_segments',
  JOB = 'user_job',
  ROLE = 'user_role',
}
